import { useEffect, useMemo, useState } from 'react'
import { useApiFormDashboardCourse } from '../../../../../../api-new/state/dashboard'
import { useApiListDashboardCourse } from '../../../../../../api-new/state/dashboard'
import { DashboardHeader, SelectRangeInterval, Widget } from '../../../../../../shared/chart/widget'
import { ChartBar } from '../../../../../../shared/chart/chart'
import { chartColorMain } from '../../../../../../shared/chart/chart-color'
import { IconCourse } from '../../../../../../shared/icon/icon'
import { useLoad } from '../../../../../../shared/hooks/load'
import { EmptyState, useFirstLoadSettled } from '../../../../../../shared/empty-state/empty-state'
import moment from 'moment'

export const DashboardCourse = () => {
  const apiFormDashboardCourse = useApiFormDashboardCourse()
  const apiListDashboardCourse = useApiListDashboardCourse()

  const [count, updateCount] = useState(0)
  const [start, updateStart] = useState(null)
  const [end, updateEnd] = useState(null)
  const [interval, updateInterval] = useState('month1')

  useEffect(() => {
    ;(async () => {
      const result = await apiFormDashboardCourse.get('organization/details')
      let start = moment(result.min).format('YYYY-MM-DD')
      let end = moment().format('YYYY-MM-DD')
      updateCount(result.count)
      updateStart(start)
      updateEnd(end)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useLoad(() => start && end && interval && apiListDashboardCourse.get(`organization?start=${start}&end=${end}&interval=${interval}`), [start, end, interval])

  const settled = useFirstLoadSettled(apiListDashboardCourse)
  const isEmpty = settled && !apiListDashboardCourse.items.length

  const chartData = useMemo(
    () => {
      if (!apiListDashboardCourse.items.length) {
        return { labels: [], data: undefined }
      }

      const labels = apiListDashboardCourse.items.map(i => i.date)
      const data = apiListDashboardCourse.items.map(i => i.count)

      const dataSet = {
        data: data,
        borderColor: chartColorMain,
        backgroundColor: chartColorMain,
        pointBackgroundColor: chartColorMain,
        pointBorderColor: chartColorMain,
        pointRadius: 1,
        borderWidth: 1,
        fill: true
      }

      return { labels: labels, data: dataSet }
    },
    [apiListDashboardCourse.items]
  )

  return (
    <Widget
      header={<DashboardHeader Icon={IconCourse} text="COURSES" value={count} />}
      body={
        isEmpty
          ? count
            ? <EmptyState compact Icon={IconCourse} title="Nothing in this range" message="Try a wider date range or a different interval." />
            : <EmptyState compact Icon={IconCourse} title="No courses yet" message="Create a course to start building content." />
          : <ChartBar labels={chartData.labels} data={chartData.data} displayGrid displayTicks />
      }
      footer={
        <SelectRangeInterval
          start={start}
          end={end}
          intervals={apiFormDashboardCourse.form.intervals}
          interval={interval}
          minDate={apiFormDashboardCourse.form.min}
          maxDate={apiFormDashboardCourse.form.max}
          onChangeStart={updateStart}
          onChangeEnd={updateEnd}
          onChangeInterval={updateInterval}
        />
      }
    />
  )
}
